export default function assetUrl(asset) {
    return asset && asset.default ? asset.default : asset;
}
